var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.149409 260.906C-2.69791 180.796 35.4081 105.984 92.2308 56.2916C148.714 6.89605 221.617 -9.79716 292.265 5.44673C366.105 21.3795 435.247 64.1988 470.337 137.877C506.925 214.699 511.674 309.772 473.274 385.501C437.113 456.814 361.314 484.856 288.262 496.948C223.114 507.731 159.044 489.659 106.092 446.277C50.2377 400.517 2.88162 337.779 0.149409 260.906Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 93,
    y1: 50.9994,
    x2: 442.929,
    y2: 413.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BAA4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandCircle);
export default __webpack_public_path__ + "static/media/brand-circle.cb88eba5604ddeeaa29bbc55e41cf9b9.svg";
export { ForwardRef as ReactComponent };